import React, { useCallback, useState } from 'react'
import { useAssetsPromise } from '../../api/query-hooks'
import { Contact } from '../../components/connected-contact'
import styled from 'styled-components'
import { Gallery } from '../../components/gallery'
import { useChangeMenuPageTitle, useLoading, useMenuId } from '../../hooks'
import { TopBodyLayout } from '../../components/top-body-layout'

const GalleryContainer = styled.div`
  width: 100%;
  padding: 1rem;
`
const Image  = styled.img`
  height: auto;
  width: 100%;
  vertical-align: bottom;
`
export const Images: React.VFC = () => {
  useChangeMenuPageTitle()
  useLoading(true)
  const [page, setPage] = useState(1)
  const menuId = useMenuId()
  const assets = useAssetsPromise(menuId, page)
  const loadMore = useCallback(async () => {
    const assetsPage = await assets
    const hasMore = !assetsPage.last
    if (hasMore) {
      setPage(page + 1)
    }
    return {
      data: assetsPage.content,
      hasMore
    }
  }, [assets, page, setPage])
  return (
    <TopBodyLayout
      top={<Contact />}
    >
      <GalleryContainer>
        <Gallery
          render={asset => <Image src={asset.resource.src} alt={asset.assertName} />}
          onLoad={loadMore}
        />
      </GalleryContainer>
    </TopBodyLayout>
  )
}
